import {AgentStore} from "./store-agents";
import {createContext} from "react";
import {LookupsStore} from "./store-lookups.";
import {ExchangeStore} from "./store-exchange";
import {UserStore} from "./store-user";
import {ModalStore} from './store-modal'
import { ToasterStore } from "./store-toaster";
import { OrderStore } from "./store-orders";
import { ContactStore } from "./store-contacts";
import {SupportTicketsStore} from "./store-support-tickets";
import {WindowStore} from "./store-window";
import {PaymentStore} from "./store-payment";


export class Root {
    Agents: AgentStore;
    Lookups: LookupsStore;
    Exchanges: ExchangeStore;
    Users: UserStore;
    Modal: ModalStore;
    Toaster : ToasterStore;
    Orders : OrderStore;
    Contacts : ContactStore;
    SupportTickets : SupportTicketsStore;
    Window : WindowStore;
    Payments : PaymentStore;

    constructor() {
        this.Agents = new AgentStore(this);
        this.Lookups = new LookupsStore(this);
        this.Exchanges = new ExchangeStore(this);
        this.Users = new UserStore(this);
        this.Modal = new ModalStore(this);
        this.Toaster = new ToasterStore(this);
        this.Orders = new OrderStore(this);
        this.Contacts = new ContactStore(this);
        this.SupportTickets = new SupportTicketsStore(this);
        this.Window = new WindowStore(this);
        this.Payments = new PaymentStore(this);
    }

    generateRandom = () => {
        return Math.floor(Math.random() * 900000) + 100000;
    }
}


export const Store = createContext(new Root());